<template>
	<article class="flex flex-col md:flex-row gap-2 md:gap-4 px-6 py-4 md:items-center border-b border-dark-grey">
		<div class="grow-0">
			<a :href="`?media_type=${ item.media_type.term_id }`" class="text-yellow md:size-8 inline-flex gap-2 uppercase items-center hover:opacity-50 hover:text-yellow!" :aria-label="item.media_type.name">
                <component :is="getIconComponent" :item="item" class="size-6" aria-hidden="true" />
                <span class="md:hidden">{{ item.media_type.name }}</span>
            </a>
		</div>
		<div class="md:shrink-0 md:grow flex flex-col">
			<a :href="item.permalink" class="underline! decoration-1! uppercase text-md leading-none font-bold text-white">{{ item.post_title }}</a>
			<span class="leading-tight uppercase" v-html="item.event_excerpt"></span>
		</div>
		<div class="md:basis-48">
			<a :href="`?project=${ item.project.term_id }`" class="tag flex gap-1 items-center bg-[#CEA06D]! text-dark-green! hover:bg-yellow!">{{ item.project.name }}</a>
		</div>
		<div class="md:basis-48">
			<a :href="`?theme=${ item.theme.term_id }`" class="leading-tight uppercase text-md text-white hover:text-yellow! hover:underline! hover:decoration-1!" v-html="item.theme.name"></a>
		</div>
		<div class="md:grow-0">
			<a
				:href="item.permalink"
				class="uppercase py-1 px-3 border text-yellow border-dark-grey rounded-3xl hover:bg-yellow! hover:text-dark-green! hover:border-yellow!"
				>Info</a
			>
		</div>
	</article>
</template>

<script setup>
import { computed } from "vue";
import { SpeakerWaveIcon, VideoCameraIcon, CameraIcon, PencilIcon } from "@heroicons/vue/24/outline";

const { item } = defineProps({
	item: {
		type: Object,
		required: true,
	},
});

const getIconComponent = computed(() => {
    return {
        audio: SpeakerWaveIcon,
        video: VideoCameraIcon,
        photography: CameraIcon,
        writing: PencilIcon,
    }[item.media_type.slug];
});

</script>
